module.exports = __webpack_public_path__ + "static/media/cover.207fd42c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DashboardCard/NewProjectCard/cover.svg
// module id = 489
// module chunks = 0